/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PageRequest } from './PageRequest';
import {
    PageRequestFromJSON,
    PageRequestFromJSONTyped,
    PageRequestToJSON,
} from './PageRequest';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
} from './SortOrder';

/**
 * 
 * @export
 * @interface ParentRoleSearchRequest
 */
export interface ParentRoleSearchRequest {
    /**
     * Zero-based page index.
     * @type {number}
     * @memberof ParentRoleSearchRequest
     */
    page: number;
    /**
     * Requested records per page. The server caps this value at 100.
     * @type {number}
     * @memberof ParentRoleSearchRequest
     */
    pageSize: number;
    /**
     * Name of the field to sort by. Allowed values depend on the endpoint and unsupported values fall back to the default ordering.
     * @type {string}
     * @memberof ParentRoleSearchRequest
     */
    sortBy?: string;
    /**
     * 
     * @type {SortOrder}
     * @memberof ParentRoleSearchRequest
     */
    sortOrder?: SortOrder;
}

/**
 * Check if a given object implements the ParentRoleSearchRequest interface.
 */
export function instanceOfParentRoleSearchRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "pageSize" in value;

    return isInstance;
}

export function ParentRoleSearchRequestFromJSON(json: any): ParentRoleSearchRequest {
    return ParentRoleSearchRequestFromJSONTyped(json, false);
}

export function ParentRoleSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentRoleSearchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'pageSize': json['pageSize'],
        'sortBy': !exists(json, 'sortBy') ? undefined : json['sortBy'],
        'sortOrder': !exists(json, 'sortOrder') ? undefined : SortOrderFromJSON(json['sortOrder']),
    };
}

export function ParentRoleSearchRequestToJSON(value?: ParentRoleSearchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'sortBy': value.sortBy,
        'sortOrder': SortOrderToJSON(value.sortOrder),
    };
}

